import React, { useState } from "react";
import { DailogBox } from "../../../components/Elements/DailogBox/DailogBox";
import { Input } from "antd";
import CustomButton from "../../../components/Elements/Buttons/CustomButtons";
import { API_URLS } from "../../../api/apiUrls";
import { postApi } from "../../../api/api_instance";
import { toast } from "react-hot-toast";
import { AcceptDialog } from "../../../components/Elements/DailogBox/AcceptDialog";

const CreateStaticPageDialog = ({
  onOpen,
  onClose,
  onSuccess,
  onSave,
  onError,
}) => {
  const [pageHeading, setPageHeading] = useState("");
  const [pageContent, setPageContent] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState({
    pageHeading: "",
    pageContent: "",
  });

  const handleSave = async () => {
    let isValid = true;
    const errors = { pageHeading: "", pageContent: "" };

    if (!pageHeading) {
      errors.pageHeading = "Page Heading is required";
      isValid = false;
    }
    if (!pageContent) {
      errors.pageContent = "Page Content is required";
      isValid = false;
    }

    setErrorMessage(errors);
    if (!isValid) return;

    setLoading(true);
    try {
      const response = await postApi({
        apiUrl: API_URLS.CREATE_STATIC_PAGE,
        data: {
          pageHeading,
          pageContent,
        },
      });

      if (response.success) {
        // toast.success("Static page created successfully!");
        if (onSave) onSave(); // ✅ show popup
        if (onSuccess) onSuccess();
        onClose();
      } else {
        if (onError)
          onError(response.message || "Failed to create static page.");
        onClose();
      }
      onClose();
    } catch (error) {
      if (onError) onClose();
      onError(error.response?.data?.message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setErrorMessage({});
    onClose();
  };

  // const handleAcceptClose = () => {
  //   setShowAcceptDialog(false);
  //   if (onSuccess) onSuccess();
  // };

  return (
    <>
      <DailogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="800px">
        <div>
          <h3 className="text-xl font-bold text-[#06513D]">
            Create Static Page
          </h3>
        </div>

        <div className="rounded-xl border mt-8 px-12">
          <div className="mt-3 mb-4">
            <hr />
          </div>

          <div className="flex flex-col gap-6">
            <Input
              value={pageHeading}
              onChange={(e) => setPageHeading(e.target.value)}
              placeholder="Page Heading"
              className="h-14 rounded-lg"
            />
            {errorMessage.pageHeading && (
              <div className="text-red-500 text-sm">
                {errorMessage.pageHeading}
              </div>
            )}

            <Input.TextArea
              value={pageContent}
              onChange={(e) => setPageContent(e.target.value)}
              placeholder="Page Content"
              className="rounded-lg"
              rows={10}
            />
            {errorMessage.pageContent && (
              <div className="text-red-500 text-sm">
                {errorMessage.pageContent}
              </div>
            )}
          </div>

          <div className="flex justify-center gap-6 p-5">
            <CustomButton
              buttonType="button"
              variant="cancel"
              buttonText="Cancel"
              onClick={handleCancel}
              className="text-base font-normal h-[50px] w-[160px]"
            />

            <CustomButton
              buttonType="button"
              variant="ok"
              buttonText="Save"
              onClick={handleSave}
              className="text-base font-normal h-[50px] w-[160px]"
              loading={loading}
            />
          </div>
        </div>
      </DailogBox>

      {/* {showAcceptDialog && (
        <AcceptDialog
          open={showAcceptDialog}
          close={handleAcceptClose}
          heading="Static Page Created"
          subheading="The static page has been successfully created."
          success={true}
        />
      )} */}
    </>
  );
};

export default CreateStaticPageDialog;
